import { ProFormaModelIds } from 'constants/proForma';
import { IExtractedProFormaSummary } from 'types/db/ExtractedProForma';
import { PRO_FORMA_STATUS } from './constants';
import { DealAutomatedRow } from './types';

export interface SortConfig {
    key: string;
    direction: 'asc' | 'desc';
}

export const getSortingIconProps = (
    key: string,
    sortedBy: SortConfig | null,
    setSortedBy: (config: SortConfig) => void,
) => ({
    columnId: key,
    isSorted: sortedBy?.key === key,
    sortedDirection: sortedBy?.key === key ? sortedBy.direction : null,
    onAscendingSort: () => setSortedBy({ key, direction: 'asc' }),
    onDescendingSort: () => setSortedBy({ key, direction: 'desc' }),
});

export const sortItems = <T extends Record<string, any>>(
    items: T[],
    sortConfig: SortConfig | null,
    key: string,
): T[] => {
    if (!items) return [];
    if (!sortConfig) return items;

    return [...items].sort((a, b) => {
        let aValue = a[sortConfig.key] || '';
        let bValue = b[sortConfig.key] || '';

        // Handle object values (like when the value is an object with a name property)
        if (typeof aValue === 'object') aValue = a?.name;
        if (typeof bValue === 'object') bValue = b?.name;

        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });
};

export const toDealAutomatedRow = (extracted: IExtractedProFormaSummary): DealAutomatedRow => ({
    isExtracted: true,
    id: extracted.id,
    name: extracted.fileName,
    isActive: false,
    createdAt: extracted.createdAt,
    updatedAt: extracted.updatedAt,
    createdBy: extracted.createdBy,
    updatedBy: '',
    boeScenarioId: null,
    boeScenario: null,
    proFormaModelId: extracted.proFormaModelId,
    proFormaModelName: ProFormaModelIds[extracted.proFormaModelId] ?? null,
    proFormaStatusId: PRO_FORMA_STATUS.SUBSTANTIALLY_COMPLETE,
    draftStep: 0,
    subprojectId: null,
    projectBudgetScenarioId: null,
});
